import { render, staticRenderFns } from "./TeamTable.component.vue?vue&type=template&id=6663feb5"
import script from "./TeamTable.component.vue?vue&type=script&lang=js"
export * from "./TeamTable.component.vue?vue&type=script&lang=js"
import style0 from "./TeamTable.component.vue?vue&type=style&index=0&id=6663feb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports